import {searchPageAttributesMap, SearchPageType} from '../search-config';
import {AbortCategory, postJsonWithBody} from '../../services/fetcher';
import {SuggestPerFieldResponse} from './search-bar-types';

export const getAutocompleteSuggestions = (
    query: string,
    searchPageType: SearchPageType,
    container: string,
    callback: (suggestResponse?: Record<string, string[]>) => void,
    queryFields?: string[]
): void => {
    postJsonWithBody<SuggestPerFieldResponse>(
        searchPageAttributesMap[searchPageType].endpoint + '/suggest',
        JSON.stringify({
            container: container,
            query: query,
            size: '10',
            fields: queryFields,
        }),
        AbortCategory.SUGGEST
    )
        .then((data: SuggestPerFieldResponse) => {
            if (data) {
                callback(data.termsPerField);
            }
        })
        .catch((error) => {
            console.error('failed to fetch suggestions', error);
        });
};
